<h6 id="identity-override-title">Identity override</h6>
<div id="identity-override-helper-text">
  Add
  <pre>#access_token=[token]&customer_slug=[customerSlug]&redirect_path=[redirectPath] to the url.</pre>
</div>
<div id="identity-override-error-messagee">
  {{ errorMessage }}
</div>
